import { render, staticRenderFns } from "./RejectionDetailModal.vue?vue&type=template&id=49401214&scoped=true&"
import script from "./RejectionDetailModal.vue?vue&type=script&lang=js&"
export * from "./RejectionDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49401214",
  null
  
)

export default component.exports